const menuElem = document.querySelector('.menu');

if (menuElem) {
  attachEvent('.menu__arrow', 'click', (ev) => {
    if (windowWidth() >= breakpointMd) {
      document.body.classList.toggle('is-open-mega-menu');
      return;
    }

    const parent = ev.target.closest('.menu__item');
    parent.classList.toggle('is-open-submenu');
    const dropdown = parent.querySelector('.menu__dropdown');
    slideToggle(dropdown, 300, 'block');
  });

  attachEvent('[data-close-menu]', 'click', (ev) => {
    document.body.classList.remove('is-open-mega-menu');
    ev.preventDefault();
  });
}
